import { render, staticRenderFns } from "./UsefulArticle.vue?vue&type=template&id=60bad644&scoped=true&"
import script from "./UsefulArticle.vue?vue&type=script&lang=js&"
export * from "./UsefulArticle.vue?vue&type=script&lang=js&"
import style0 from "./UsefulArticle.vue?vue&type=style&index=0&id=60bad644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bad644",
  null
  
)

export default component.exports